import { useEffect, useRef, useState } from 'react';
import Login from "../components/Authentication/Login";
import SignUp from "../components/Authentication/Signup";
import { useHistory } from "react-router-dom";

const Homepage = () => {
    const history = useHistory();
    const [LoginSignup, setLoginSignup] = useState(true);
    const [isFormActive, setIsFormActive] = useState(false);
    
    const touchStart = useRef(null);
    const touchEnd = useRef(null);
    const minSwipeDistance = 50;

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("userInfo"));
        if (user) history.push("/chats");
    }, [history]);

    const onTouchStart = (e) => {
        touchEnd.current = null;
        touchStart.current = e.targetTouches[0].clientY;
    };

    const onTouchMove = (e) => {
        touchEnd.current = e.targetTouches[0].clientY;
    };

    const onTouchEnd = () => {
        if (!touchStart.current || !touchEnd.current) return;
        
        const distance = touchStart.current - touchEnd.current;

        if (distance > minSwipeDistance) {
            setIsFormActive(true);
        } else if (distance < -minSwipeDistance) {
            setIsFormActive(false);
        }
        
        touchStart.current = null;
        touchEnd.current = null;
    };
    const bgRef = useRef(null);
    const handleMouseMove = (e) => {
        const { clientX, clientY } = e;
        const x = (clientX / window.innerWidth - 0.5) * 40; 
        const y = (clientY / window.innerHeight - 0.5) * 40;
        
        const root = document.documentElement;
        root.style.setProperty('--mouse-x', `${x}px`);
        root.style.setProperty('--mouse-y', `${y}px`);
    };
    const handleTouchMove = (e) => {
    const touch = e.touches[0];
    const x = (touch.clientX / window.innerWidth - 0.5) * 40; 
    const y = (touch.clientY / window.innerHeight - 0.5) * 40;
    const root = document.documentElement;
    root.style.setProperty('--mouse-x', `${x}px`);
    root.style.setProperty('--mouse-y', `${y}px`);
};


    const EncryptionTypewriter = (props) => {
        const fullText = props.fullText;
        const textsArray = ["X", "0", "1", "$", "&", "@", "!", "#", "?", "*", "%", "Z"];
        
        const [displayedText, setDisplayedText] = useState("");
        const [cipherText, setCipherText] = useState("");
        const [index, setIndex] = useState(0);
        const [isTyping, setIsTyping] = useState(true);

        useEffect(() => {
            if (isTyping && index < fullText.length) {
            const timeout = setTimeout(() => {
                setDisplayedText(prev => prev + fullText[index]);
                setIndex(prev => prev + 1);
            }, 150);
            return () => clearTimeout(timeout);
            } else if (!isTyping && index > 0) {
            const timeout = setTimeout(() => {
                setDisplayedText(prev => prev.slice(0, -1));
                setIndex(prev => prev - 1);
            }, 80);
            return () => clearTimeout(timeout);
            } else if (index === fullText.length) {
            const delay = setTimeout(() => setIsTyping(false), 3000);
            return () => clearTimeout(delay);
            } else if (index === 0 && !isTyping) {
            const delay = setTimeout(() => setIsTyping(true), 1000);
            return () => clearTimeout(delay);
            }
        }, [index, isTyping]);

        useEffect(() => {
            const interval = setInterval(() => {
            let randomStr = "";
            for (let i = 0; i < displayedText.length; i++) {
                const randomSymbol = textsArray[Math.floor(Math.random() * textsArray.length)];
                randomStr += randomSymbol;
            }
            setCipherText(randomStr);
            }, 100); 

            return () => clearInterval(interval);
        }, [displayedText]);

        return (
            <div className="typewriter_group">
            <input 
                type="text" 
                readOnly 
                value={displayedText} 
                className="privacy_typewriter_input" 
                placeholder="" 
            />
            <input 
                type="text" 
                readOnly 
                value={cipherText} 
                className="cipher_input" 
                placeholder="" 
            />
            </div>
        );
    };


    return (
        <div className="landing_wrapper"
            onTouchStart={onTouchStart}
            onMouseMove={handleMouseMove}
            onTouchMove={handleTouchMove}
            onTouchEnd={onTouchEnd} 
        >
            <div 
                className={`promo_section ${!isFormActive ? 'expanded' : 'collapsed'}`}
                onClick={() => setIsFormActive(!isFormActive)} 
            >
                <div className="parallax_container">
                    <div className="parallax_bg"></div>
                    <div className="parallax_overlay_image"></div>
                </div>
                <h1>Secure Messenger SICH</h1>
                <div className="promo_content">
                    <div className="floating_icons">
                        <div className="icon i1"> 
                            <EncryptionTypewriter fullText={"Самый безопасный чат"}/> 
                        </div>
                        <div className="icon i5"> 
                            <EncryptionTypewriter fullText={"Exchange of secret messages"}/> 
                        </div>
                         <div className="icon i2"> 
                            <EncryptionTypewriter fullText={"Только ты понимаєшь сообщение"}/> 
                        </div>
                        <div className="icon i3"> 
                            <EncryptionTypewriter fullText={"Niemand wird es jemals erfahren"}/> 
                        </div>
                        <div className="icon i4"> 
                            <EncryptionTypewriter fullText={"Total privacy by default"}/> 
                        </div>
                      
                    </div>
                </div>
            </div>

           <div className={`login_signup_container_mobile ${isFormActive ? 'expanded' : 'collapsed'}`}
                onClick={() => !isFormActive && setIsFormActive(!isFormActive)} 
            >
                <div className="drag_handle_line" onClick={() => setIsFormActive(!isFormActive)}></div>
                
                <div className='login_signup_box chats_header'>
                    <h2 fontSize="2xl" fontFamily="Work sans">
                        <span><img src="/images/logo192.png" alt="SICH"/></span><span>SICH messenger</span>
                    </h2>
                </div>

                <div className={`form_wrapper ${isFormActive ? 'visible' : 'hidden'}`}>
                    <div className="navigation">
                        <div className={`navigation-li ${LoginSignup ? 'active' : ''}`}> 
                            <button onClick={() => setLoginSignup(true)}> Login </button> 
                        </div>
                        <div className={`navigation-li ${!LoginSignup ? 'active' : ''}`}> 
                            <button onClick={() => setLoginSignup(false)}> SignUp </button> 
                        </div>
                    </div>
                    
                    <div className='loginFormBlock'>
                        { LoginSignup ? <Login setLoginSignup={setLoginSignup}/> : <SignUp setLoginSignup={setLoginSignup} /> }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Homepage;
